module.exports = __webpack_public_path__ + "static/client_2_before-a0d5d2bda9e48978fa2eba8343f41f94.jpg";